export interface TokenStore {
  get: () => string | null;
  set: (token: string) => void;
  clear: () => void;
}

function createTokenStore(): TokenStore {
  let value: string | null = null;
  return {
    get: () => value,
    set: (token: string) => {
      value = token;
    },
    clear: () => {
      value = null;
    },
  };
}

export const tokenStore: TokenStore = createTokenStore();

export function getToken(): string | null {
  return tokenStore.get();
}
